import React, { useContext } from 'react';

const GlobalContext = React.createContext(null);
export default GlobalContext;

export const useGlobalContext= () =>  useContext(GlobalContext) ;